import isExperienceEditor from '@utils/is-experience-editor';

(function (window) {

    var abstracts = function () {
        var ui = {};
        // Number of abstract children to reveal at a time
        var ABSTRACT_CHILD_INCREMENT = 10;

        function cacheUI() {
            ui.$abstractListingList = document.querySelector("div[class='abstracts-listing__list']");
            ui.$btnShowAbstractChildren = document.getElementById("btnShowAbstractChildren");
        }

        function initAbstractChildren(e) {
            if (!isExperienceEditor) {
                showMoreAbstractChildren();
            } else {
                if (ui.$abstractListingList) {
                    for(var i=0; i<ui.$abstractListingList.children.length; i++)
                    {
                        ui.$abstractListingList.children[i].style.setProperty("display","block");
                    }
                }
            }
        }

        function showMoreAbstractChildren() {
            if (ui.$abstractListingList && ui.$abstractListingList.children.length > 0) {
                var revealedChildCounter = 0;
                var iteratedChildCounter = 0;
                var youCanDeletethis = 'markcheck';

                while(revealedChildCounter < ABSTRACT_CHILD_INCREMENT && iteratedChildCounter < ui.$abstractListingList.children.length)
                {
                    if(ui.$abstractListingList.children[iteratedChildCounter].style.getPropertyValue("display") == "none")
                    {
                        ui.$abstractListingList.children[iteratedChildCounter].style.setProperty("display","block");
                        revealedChildCounter += 1;
                    }
                    iteratedChildCounter += 1;
                }

                if(ui.$abstractListingList.querySelectorAll("[style='display:none;']").length <= 0)
                {
                    ui.$btnShowAbstractChildren.style.setProperty("display", "none");
                    youCanDeletethis = 'markcheckdone';
                }
            }
        }

        function bindEvents() {
            ui.$btnShowAbstractChildren.addEventListener('click', showMoreAbstractChildren);
        }

        function init() {
            if ($('.abstracts-listing').length <= 0) {
                return;
            }
    
            cacheUI();
            bindEvents();
            initAbstractChildren();
        }

        return {
            init: init
        };
    };

    var abstractsObj = abstracts();
    abstractsObj.init();
})(window);